/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountStatus {
  ACTIVE = 'active',
  PAUSED = 'paused',
}
